module.exports = __webpack_public_path__ + "img/rent_camper_2.e06241f3.jpg";